<template>
  <card-info title="Constructive Alignment Design">
    <template v-slot:above-title>
      <h3 class="mb-4 font-weight-bold"></h3>
    </template>

    <template v-slot:below-title>
      <div class="learning-outcome-description mt-4 mb-1">
        <!-- <div ref="learning-outcome-description" class="ml-3">
          Learning Outcome:
          <span class="text-pre-line">{{ learningOutcome.title }}</span>
        </div> -->
      </div>
      <div class="mt-5 d-flex">
        <div class="card card-box mr-4 w-50">
          <div class="card-header bg-light">
            <div class="card-header--title">
              <div class="font-weight-bold">Assessment</div>
            </div>
          </div>
          <div ref="card-body-assessment" class="card-body">
            <ul v-for="(post, index) in postsAssessment" :key="index" class="mb-2">
              <li ref="post-assessment-title">{{ post.title }}</li>
              <div>
                <b-badge
                  v-if="post.evaluate_learning_outcome"
                  :id="`popoverPosition-${index}`"
                  ref="badge"
                  variant="neutral-primary"
                  class="text-primary badge__tag-evaluate-lo mr-auto"
                >
                  Evaluate learning outcome
                </b-badge>
              </div>
            </ul>
          </div>
        </div>
        <div class="card card-box w-50">
          <div class="card-header bg-light">
            <div class="card-header--title">
              <div class="font-weight-bold">Learning Activity</div>
            </div>
          </div>
          <div ref="card-body-learning" class="card-body">
            <ul v-for="(post, index) in postsLearning" :key="index" class="mb-2">
              <li ref="post-learning-title">{{ post.title }}</li>
            </ul>
          </div>
        </div>
      </div>
    </template>
  </card-info>
</template>

<script>
import CardInfo from './CardInfo';
import { learningUnitInfoMixin } from '@/mixins/learningUnitInfoMixin';
import Post from '@/models/Post';

export default {
  name: 'ConstructiveDesign',

  components: {
    CardInfo
  },

  mixins: [learningUnitInfoMixin],

  computed: {
    posts() {
      return Post.query().where('learning_unit_id', this.learningUnitId).get();
    },

    postsLearning() {
      return this.posts.filter((post) => post.is_submission === false && post.meeting === null);
    },

    postsAssessment() {
      return this.posts.filter((post) => post.is_submission === true);
    }
  }
};
</script>

<style lang="scss" scoped></style>
